// Copyright (c) 2021 8th Wall, Inc.
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
/* globals XR8 XRExtras THREE */

var isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return (
      navigator.userAgent.match(/IEMobile/i) ||
      navigator.userAgent.match(/WPDesktop/i)
    );
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};

if (!isMobile.any()) {
  window.location.href = '/desktop.html';
}

function initMutationObserver() {
  let inDom = false;
  const observer = new MutationObserver(() => {
    if (document.querySelector('.prompt-box-8w')) {
      if (!inDom) {
        const box = document.querySelector('.prompt-box-8w');
        const text = document.querySelector('.prompt-box-8w p');
        const btnDeny = document.querySelector('.prompt-button-8w');
        const btnOk = document.querySelector('.button-primary-8w');

        // Nascondo bottone deny
        btnDeny.style.display = 'none';

        // Aggiusto il font del testo
        box.style.fontFamily = 'HelveticaNeue';
        box.style.backgroundColor = 'rgba(255, 255, 255, .8)';
        box.style.color = 'black';

        btnOk.innerHTML = 'Ok';
        btnOk.style.backgroundColor = 'white';
        btnOk.style.color = '#555555';
        btnOk.style.fontSize = '16px';
        btnOk.style.borderRadius = '9999px';
        btnOk.style.marginLeft = '10px';
        btnOk.style.marginRight = '10px';

        text.style.fontSize = '18px';
        text.style.lineHeight = '23px';
      }
      inDom = true;
    } else if (inDom) {
      inDom = false;
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true });
}

const imageTargetPipelineModule = () => {
  const modelFile = './static/Heart.glb';
  const videoFile = './jellyfish-video.mp4';

  const loader = new THREE.GLTFLoader();
  const hdrLoader = new RGBELoader();
  const clock = new THREE.Clock();

  let positioned;
  let heartAppeared;
  let model;
  let video, videoObj;
  let mixer;

  // Populates some object into an XR scene and sets the initial camera position. The scene and
  // camera come from xr3js, and are only available in the camera loop lifecycle onStart() or later.
  const initXrScene = ({ scene, camera, renderer }) => {
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.depthTest = false;
    renderer.physicallyCorrectLights = true;
    // create the video element
    video = document.createElement('video');
    video.src = videoFile;
    video.setAttribute('preload', 'auto');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const texture = new THREE.VideoTexture(video);
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.format = THREE.RGBFormat;
    texture.crossOrigin = 'anonymous';

    videoObj = new THREE.Mesh(
      new THREE.PlaneGeometry(2.2, 2.2),
      new THREE.MeshStandardMaterial({
        map: texture,
        transparent: true,
        opacity: 0,
        metalness: 0,
        roughness: 1,
      })
    );
    // Hide video until image target is detected.
    videoObj.visible = false;
    scene.add(videoObj);
    video.load();

    // Load 3D model
    loader.load(
      // resource URL
      modelFile,
      // loaded handler
      (gltf) => {
        const pmrem = new THREE.PMREMGenerator(renderer);

        hdrLoader.load('./static/sunset2.hdr', (t) => {
          let hdr = pmrem.fromEquirectangular(t).texture;
          gltf.scene.position.y = 5;
          gltf.scene.traverse((o) => {
            if (o.material) {
              o.material.side = THREE.FrontSide;
              o.material.transparent = false;
              o.material.metalness = 1;
              o.material.envMap = hdr;
              o.material.needsUpdate;
              o.material.opacity = 1;
            }
          });

          mixer = new THREE.AnimationMixer(gltf.scene);
          mixer.timeScale = 0.6;
          let actions = [];
          for (let i = 0; i < gltf.animations.length; i++) {
            actions.push(mixer.clipAction(gltf.animations[i]));
            actions[i].clampWhenFinished = true;
            actions[i].loop = THREE.LoopOnce;
            actions[i].play();
          }
        });
        model = gltf.scene;
        scene.add(model);
        model.scale.set(0, 0, 0);
        // Hide 3D model until image target is detected.
        model.visible = false;
      }
    );

    // Add soft white light to the scene.
    // This light cannot be used to cast shadows as it does not have a direction.

    // Set the initial camera position relative to the scene we just laid out. This must be at a
    // height greater than y=0.
    camera.position.set(0, 3, 0);
  };

  // Places content over image target
  const showTarget = ({ detail }) => {
    // When the image target named 'model-target' is detected, show 3D model.
    // This string must match the name of the image target uploaded to 8th Wall.
    if (detail.name === 'Scritte' && !positioned && model) {
      let newRot = new THREE.Quaternion(
        detail.rotation.x,
        detail.rotation.y + Math.PI / 2,
        detail.rotation.z,
        detail.rotation.w
      );
      model.position.copy(detail.position);
      model.quaternion.copy(detail.rotation);
      model.scale.set(0, 0, 0);

      model.visible = true;
      const modelScale = { scale: 0 };
      const modelScaleEnd = { scale: detail.scale * 5 };

      new TWEEN.Tween(modelScale)
        .to(modelScaleEnd, 4000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          model.scale.set(modelScale.scale, modelScale.scale, modelScale.scale);
        })
        .onComplete(() => {
          heartAppeared = true;
        })
        .start(); // Start the tween immediately.
      positioned = true;
    }
    // When the image target named 'video-target' is detected, play video.
    // This string must match the name of the image target uploaded to 8th Wall.
    if (detail.name === 'ScritteAAA') {
      if (!positioned) {
        console.log('tracking');
        const rot = new THREE.Quaternion(
          detail.rotation.x,
          detail.rotation.y,
          detail.rotation.z,
          detail.rotation.w
        );
        const pos = new THREE.Vector3(
          detail.position.x,
          detail.position.y,
          detail.position.z
        );
        const modelOpacity = { opacity: 0 };
        const modelOpacityEnd = { opacity: 1 };

        new TWEEN.Tween(modelOpacity)
          .to(modelOpacityEnd, 4000)
          .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
          .onUpdate(() => {
            console.log(modelOpacity.opacity);
            videoObj.material.opacity = modelOpacity.opacity;
          })
          .start(); // Start the tween immediately.

        console.log(detail.rotation);
        videoObj.position.copy(pos);
        videoObj.quaternion.copy(detail.rotation);
        videoObj.scale.set(
          detail.scale / 1.3,
          detail.scale / 1.3,
          detail.scale / 1.3
        );
        videoObj.visible = true;
        video.play();
        positioned = true;
      }
    }
  };

  // Hides the image frame when the target is no longer detected.
  const hideTarget = ({ detail }) => {
    if (detail.name === 'Scritte') {
    }
  };

  // Grab a handle to the threejs scene and set the camera position on pipeline startup.
  const onStart = ({ canvas }) => {
    const { scene, camera, renderer } = XR8.Threejs.xrScene(); // Get the 3js scene from XR

    initXrScene({ scene, camera, renderer }); // Add content to the scene and set starting camera position.

    // prevent scroll/pinch gestures on canvas
    canvas.addEventListener('touchmove', (event) => {
      event.preventDefault();
    });

    const animate = (time) => {
      requestAnimationFrame(animate);
      if (mixer && heartAppeared) {
        const delta = clock.getDelta();
        mixer.update(delta);
      }

      TWEEN.update(time);
    };

    animate();

    // Sync the xr controller's 6DoF position and camera paremeters with our scene.
    XR8.XrController.updateCameraProjectionMatrix({
      origin: camera.position,
      facing: camera.quaternion,
    });
  };

  return {
    // Camera pipeline modules need a name. It can be whatever you want but must be
    // unique within your app.
    name: 'threejs-flyer',

    // onStart is called once when the camera feed begins. In this case, we need to wait for the
    // XR8.Threejs scene to be ready before we can access it to add content. It was created in
    // XR8.Threejs.pipelineModule()'s onStart method.
    onStart,

    // Listeners are called right after the processing stage that fired them. This guarantees that
    // updates can be applied at an appropriate synchronized point in the rendering cycle.
    listeners: [
      { event: 'reality.imagefound', process: showTarget },
      { event: 'reality.imageupdated', process: showTarget },
      { event: 'reality.imagelost', process: hideTarget },
    ],
  };
};

const onxrloaded = () => {
  initMutationObserver();

  // If your app only interacts with image targets and not the world, disabling world tracking can
  // improve speed.
  XR8.XrController.configure({ disableWorldTracking: false });
  XR8.addCameraPipelineModules([
    // Add camera pipeline modules.
    // Existing pipeline modules.
    XR8.GlTextureRenderer.pipelineModule(), // Draws the camera feed.
    XR8.Threejs.pipelineModule(), // Creates a ThreeJS AR Scene.
    XR8.XrController.pipelineModule(), // Enables SLAM tracking.
    XRExtras.AlmostThere.pipelineModule(), // Detects unsupported browsers and gives hints.
    XRExtras.FullWindowCanvas.pipelineModule(), // Modifies the canvas to fill the window.
    XRExtras.Loading.pipelineModule(), // Manages the loading screen on startup.
    XRExtras.RuntimeError.pipelineModule(), // Shows an error image on runtime error.
    // Custom pipeline modules.
    imageTargetPipelineModule(), // Places 3d model and video content over detected image targets.
  ]);

  // Open the camera and start running the camera run loop.
  XR8.run({ canvas: document.getElementById('camerafeed') });
};

// Show loading screen before the full XR library has been loaded.
const load = () => {
  XRExtras.Loading.showLoading({ onxrloaded });
};
window.onload = () => {
  window.XRExtras ? load() : window.addEventListener('xrextrasloaded', load);
};
